import axiosInstance from "./AxiosInstance";

// Static token, if needed for reference
const token = "e532c7ba3d7dd872df0f67576c161969";

// Fetch import leads list with pagination
// export function getImportLeads( pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return axiosInstance.post("/lead/importLeadsList",    pagination,
//     pageid,
//     search_by, search_keyword, sort_by, sort_order);
// }
// export function getImportLeads( pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return axiosInstance.post("/lead/importLeadsList", { // Wrap parameters in an object
//     pagination,
//     pageid,
//     search_by,
//     search_keyword,
//     sort_by,
//     sort_order
//   });
// }
export function getImportLeads(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("/lead/importLeadsList", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order
  });
}


// Create a new import lead
export function createImportLeads(formData) {
  // Make sure we're sending FormData with the correct headers
  return axiosInstance.post("/lead/importLeads", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// Update an existing import lead
export function updateImportLeads(formData) {
  return axiosInstance.post("/lead/editImportLead", formData);
}

// Delete an import lead
export function deleteImportLeads(importLead) {
  return axiosInstance.post("/lead/deleteImportLead", importLead);
}

// Add this utility function that was missing from the actions
export function formatImportLeads(data) {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  return data.map((lead) => ({
    importLead_id: lead.import_lead_id || lead.id, // Ensure consistent naming
    import_lead_id: lead.import_lead_id || lead.id, // Keep original for API compatibility
    campaign_type: lead.campaign_type,
    social_media_type: lead.social_media_type,
    import_file: lead.import_file,
    disease_id: lead.disease_id,
    created_at: lead.created_at,
    updated_at: lead.updated_at,
  }));
}
